import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { CircularProgress } from '@mui/material';

const styleSheet = theme => ({
    root: {
        flexGrow: 1,
      },
    flex: {
        flex: 1,
    },
});

class SavingSpinner extends Component {
    
    render() {
        const classes = this.props.classes;
        return (
            <CircularProgress className={classes.progress} style={{marginRight:'5px'}}
                color="inherit" size={20} thickness={3}/>
          );
    }
}
  
export default withStyles(styleSheet)(SavingSpinner);